"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENDPOINTS = void 0;
const DISTRIBUTOR_ENDPOINTS = {
    GET_ALL_PARTNER_CATALOG_PRODUCTS: {
        path: '/v1/cooperatives/{cooperative_id}/products',
        applyParams: (params) => `/v1/cooperatives/${params.cooperativeId}/products`,
    },
    GET_ALL_BASIC_DISTRIBUTOR_VARIANTS: {
        path: '/v1/cooperatives/{cooperative_id}/cooperative-variants',
        applyParams: (params) => `/v1/cooperatives/${params.cooperativeId}/cooperative-variants`,
    },
    GET_ONE_PARTNER_CATALOG_PRODUCT: {
        path: '/v1/cooperatives/{cooperative_id}/products/{product_code}',
        applyParams: (params) => `/v1/cooperatives/${params.cooperativeId}/products/${params.productId}`,
    },
    GET_DISTRIBUTOR_ZONE_CHARGES: {
        path: '/backoffice/v1/cooperatives/{cooperative_id}/zone-charges',
        applyParams: (params) => `/backoffice/v1/cooperatives/${params.cooperativeId}/zone-charges`,
    },
    GET_ALL_PARTNER_PRODUCTS: {
        path: '/backoffice/v1/partners/{partner_id}/partner-products',
        applyParams: (params) => `/backoffice/v1/partners/${params.partnerId}/partner-products`,
    },
    GET_ALL_DISTRIBUTOR_VARIANTS: {
        path: '/v1/cooperatives/{cooperative_id}/variants',
        applyParams: (params) => `/v1/cooperatives/${params.cooperativeId}/variants`,
    },
    GET_ALL_DISTRIBUTOR_PRODUCTS_SUMMARY: {
        path: '/v1/cooperative-products/summary',
    },
    GET_ALL_DISTRIBUTOR_IMPORT_REPORTS: {
        path: '/v1/cooperatives/{distributorId}/{reportType}/import-reports',
        applyParams: (params) => `/v1/cooperatives/${params.distributorId}/${params.reportType}/import-reports`,
    },
    GET_ONE_DISTRIBUTOR_IMPORT_REPORT: {
        path: '/v1/cooperatives/{distributorId}/{reportType}/import-reports/{importReportId}',
        applyParams: (params) => `/v1/cooperatives/${params.distributorId}/${params.reportType}/import-reports/${params.importReportId}`,
    },
    GET_DISTRIBUTOR_LATEST_IMPORT_REPORT: {
        path: '/v1/cooperatives/{distributorId}/{reportTypeLatest}/import-reports/latest',
        applyParams: (params) => `/v1/cooperatives/${params.distributorId}/${params.reportTypeLatest}/import-reports/latest`,
    },
    UPDATE_DISTRIBUTOR_PRODUCT: {
        path: '/v1/cooperatives/{cooperative_id}/products/{product_id}',
        applyParams: (params) => `/v1/cooperatives/${params.cooperativeId}/products/${params.productId}`,
    },
    UPDATE_DISTRIBUTOR_VARIANT: {
        path: '/v1/cooperative-variants/{cooperative_variant_id}',
        applyParams: (params) => `/v1/cooperative-variants/${params.cooperativeVariantId}`,
    },
    UPDATE_DISTRIBUTOR_SUGGESTED_PRODUCTS: {
        path: '/v1/cooperatives/{cooperative_id}/products/{product_id}/associated-product',
        applyParams: (params) => `/v1/cooperatives/${params.cooperativeId}/products/${params.productId}/associated-product`,
    },
    DELETE_DISTRIBUTOR_SUGGESTED_PRODUCTS: {
        path: '/v1/cooperatives/{cooperative_id}/products/{product_id}/associated-product',
        applyParams: (params) => `/v1/cooperatives/${params.cooperativeId}/products/${params.productId}/associated-product`,
    },
    PUT_DISTRIBUTOR_CATALOG: {
        path: '/v1/cooperatives/{cooperative_id}/variants',
        applyParams: (params) => `/v1/cooperatives/${params.cooperativeId}/variants`,
    },
    PUT_COOPERATIVE_CATALOG_V2: {
        path: '/v2/cooperatives/{cooperative_id}/variants/{sub_task_id}',
        applyParams: (params) => `/v2/cooperatives/${params.cooperativeId}/variants/${params.subTaskId}`,
    },
    PUT_PARTNER_PRODUCT: {
        path: '/backoffice/v1/partners/{partner_id}/partner-products',
        applyParams: (params) => `/backoffice/v1/partners/${params.partnerId}/partner-products`,
    },
    PUT_PARTNER_PRODUCT_V2: {
        path: '/backoffice/v2/partners/{partner_id}/partner-products/{sub_task_id}',
        applyParams: (params) => `/backoffice/v2/partners/${params.partnerId}/partner-products/${params.subTaskId}`,
    },
};
const PRODUCTS_ENDPOINTS = {
    GET_ONE_PRODUCT: {
        path: '/v1/products/{product_code}',
        applyParams: (product_code) => `/v1/products/${product_code}`,
    },
    GET_PRODUCTS_BY_SKUS: {
        path: '/v1/product-by-skus',
    },
    GET_PRODUCTS: {
        path: '/v1/products',
    },
    GET_PRODUCTS_SUMMARY: {
        path: '/v1/products/summary',
    },
    GET_PRODUCTS_SUMMARY_FULL: {
        path: '/v1/products-summary/full',
    },
};
const DATASET_ENDPOINTS = {
    CREATE_DATASET_PRODUIT: {
        path: '/v1/dataset/products',
    },
    GET_ONE_DATASET_PRODUIT: {
        path: '/v1/dataset/products/{productId}',
        applyParams: (productId) => `/v1/dataset/products/${productId}`,
    },
    GET_DATASET_PRODUITS: {
        path: '/v1/dataset/products',
    },
    DELETE_DATASET_PRODUIT: {
        path: '/v1/dataset/products/{productId}',
        applyParams: (productId) => `/v1/dataset/products/${productId}`,
    },
    ADD_VARIANT_DATASET_TO_PARTNER_CATALOG: {
        path: '/v1/dataset/cooperatives/{distributorId}/variants',
        applyParams: (distributorId) => `/v1/dataset/cooperatives/${distributorId}/variants`,
    },
    REMOVE_VARIANT_DATASET_FROM_PARTNER_CATALOG: {
        path: '/v1/dataset/cooperatives/{distributorId}/variants/{distributorVariantId}',
        applyParams: (distributorId, variantId) => `/v1/dataset/cooperatives/${distributorId}/variants/${variantId}`,
    },
    SUBMIT_DATASET_PRODUCT_INDEXING_TASK: {
        path: '/v1/dataset/products/indexing',
        applyParams: () => `/v1/dataset/products/indexing`,
    },
    SUBMIT_DATASET_PARTNER_INDEXING_TASK: {
        path: '/v1/dataset/cooperatives/{distributorId}/indexing',
        applyParams: (distributorId) => `/v1/dataset/cooperatives/${distributorId}/indexing`,
    },
    SUBMIT_DATASET_PARTNER_SYNC_INDEXING_TASK: {
        path: '/v1/dataset/cooperatives/{distributorId}/indexing/sync',
        applyParams: (distributorId) => `/v1/dataset/cooperatives/${distributorId}/indexing/sync`,
    },
    SUBMIT_DATASET_PARTNER_SYNC_DELETE_INDEXING_TASK: {
        path: '/v1/dataset/cooperatives/{distributorId}/indexing/sync/delete',
        applyParams: (distributorId) => `/v1/dataset/cooperatives/${distributorId}/indexing/sync/delete`,
    },
    GET_DATASET_PARTNER_INDEXING_TASK: {
        path: '/v1/dataset/cooperatives/{distributorId}/indexing',
        applyParams: (distributorId) => `/v1/dataset/cooperatives/${distributorId}/indexing`,
    },
};
const CUSTOM_CONFIG_ENDPOINTS = {
    GET_CUSTOM_CONFIG: {
        path: '/v1/products/custom-configurations/{customConfigId}',
        applyParams: (customConfigId) => `/v1/products/custom-configurations/${customConfigId}`,
    },
    GET_PARTNER_CUSTOM_CONFIG: {
        path: '/v1/products/partners/{distributorId}/custom-configurations/{customConfigId}',
        applyParams: (distributorId, customConfigId) => `/v1/products/partners/${distributorId}/custom-configurations/${customConfigId}`,
    },
    UPDATE_PARTNER_CUSTOM_CONFIG: {
        path: '/v1/products/partners/{distributorId}/custom-configurations/{customConfigId}',
        applyParams: (distributorId, customConfigId) => `/v1/products/partners/${distributorId}/custom-configurations/${customConfigId}`,
    },
    DELETE_PARTNER_CUSTOM_FILTER: {
        path: '/v1/products/partners/{distributorId}/custom-configurations/filters',
        applyParams: (distributorId) => `/v1/products/partners/${distributorId}/custom-configurations/filters`,
    },
};
const VIRTUAL_CATEGORY_ENDPOINTS = {
    // Import (CSV)
    IMPORT_VIRTUAL_CATEGORIES: {
        path: '/v1/products/partners/{partner_id}/virtual-categories/import',
        applyParams: (params) => `/v1/products/partners/${params.partnerId}/virtual-categories/import`,
    },
    IMPORT_VIRTUAL_CATEGORIES_AUTO: {
        path: '/v1/products/partners/{partner_id}/virtual-categories/import/{sub_task_id}',
        applyParams: (params) => `/v1/products/partners/${params.partnerId}/virtual-categories/import/${params.subTaskId}`,
    },
    // Export (CSV)
    EXPORT_VIRTUAL_CATEGORIES: {
        path: '/v1/products/partners/{partner_id}/virtual-categories/export',
        applyParams: (params) => `/v1/products/partners/${params.partnerId}/virtual-categories/export`,
    },
    // CRUD (JSON) - Distributor-scoped
    GET_ALL_VIRTUAL_CATEGORIES: {
        path: '/v1/products/partners/{partner_id}/virtual-categories',
        applyParams: (params) => `/v1/products/partners/${params.partnerId}/virtual-categories`,
    },
    CREATE_VIRTUAL_CATEGORY: {
        path: '/v1/products/partners/{partner_id}/virtual-categories',
        applyParams: (params) => `/v1/products/partners/${params.partnerId}/virtual-categories`,
    },
    GET_VIRTUAL_CATEGORY: {
        path: '/v1/products/partners/{partner_id}/virtual-categories/{virtualCategoryId}',
        applyParams: (params) => `/v1/products/partners/${params.partnerId}/virtual-categories/${params.virtualCategoryId}`,
    },
    UPDATE_VIRTUAL_CATEGORY: {
        path: '/v1/products/partners/{partner_id}/virtual-categories/{virtualCategoryId}',
        applyParams: (params) => `/v1/products/partners/${params.partnerId}/virtual-categories/${params.virtualCategoryId}`,
    },
    DELETE_VIRTUAL_CATEGORY: {
        path: '/v1/products/partners/{partner_id}/virtual-categories/{virtualCategoryId}',
        applyParams: (params) => `/v1/products/partners/${params.partnerId}/virtual-categories/${params.virtualCategoryId}`,
    },
    GET_VIRTUAL_CATEGORY_BY_SLUG: {
        path: '/v1/products/partners/{partner_id}/virtual-categories/by-slug/{slug}',
        applyParams: (params) => `/v1/products/partners/${params.distributorId}/virtual-categories/by-slug/${params.slug}`,
    },
    // CRUD (JSON) - Global (no distributor)
    GET_ALL_GLOBAL_VIRTUAL_CATEGORIES: {
        path: '/v1/products/virtual-categories',
        applyParams: () => `/v1/products/virtual-categories`,
    },
    CREATE_GLOBAL_VIRTUAL_CATEGORY: {
        path: '/v1/products/virtual-categories',
        applyParams: () => `/v1/products/virtual-categories`,
    },
    GET_GLOBAL_VIRTUAL_CATEGORY: {
        path: '/v1/products/virtual-categories/{virtualCategoryId}',
        applyParams: (params) => `/v1/products/virtual-categories/${params.virtualCategoryId}`,
    },
    UPDATE_GLOBAL_VIRTUAL_CATEGORY: {
        path: '/v1/products/virtual-categories/{virtualCategoryId}',
        applyParams: (params) => `/v1/products/virtual-categories/${params.virtualCategoryId}`,
    },
    DELETE_GLOBAL_VIRTUAL_CATEGORY: {
        path: '/v1/products/virtual-categories/{virtualCategoryId}',
        applyParams: (params) => `/v1/products/virtual-categories/${params.virtualCategoryId}`,
    },
    GET_GLOBAL_VIRTUAL_CATEGORY_BY_SLUG: {
        path: '/v1/products/virtual-categories/by-slug/{slug}',
        applyParams: (params) => `/v1/products/virtual-categories/by-slug/${params.slug}`,
    },
};
const BFF_ENDPOINTS = {
    POST_PARTNER_FLASH_ORDER: {
        path: '/v1/produit/bff/partner/{partnerId}/flash-order',
        applyParams: (params) => `/v1/produit/bff/partner/${params.distributorId}/flash-order`,
    },
    GET_PARTNER_FLASH_ORDER: {
        path: '/v1/produit/bff/partner/{partnerId}/flash-order/{flashOrderId}',
        applyParams: (params) => `/v1/produit/bff/partner/${params.distributorId}/flash-order/${params.flashOrderId}`,
    },
    GET_DISTRIBUTOR_PRODUCT_WITH_OFFERS: {
        path: '/v1/produit/bff/partner/{partnerId}/product/{productId}',
        applyParams: (params) => `/v1/produit/bff/partner/${params.distributorId}/product/${params.productId}`,
    },
};
const FLASH_ORDER_ENDPOINTS = {
    CREATE_FLASH_ORDER: {
        path: '/v1/flash-orders',
    },
    GET_FLASH_ORDER: {
        path: '/v1/flash-orders/{flashOrderId}',
        applyParams: (flashOrderId) => `/v1/flash-orders/${flashOrderId}`,
    },
};
const SHOPPING_LIST_ENDPOINTS = {
    CREATE_REGISTERED_SHOPPING_LIST: {
        path: '/v1/registered-shopping-lists',
    },
};
exports.ENDPOINTS = {
    ...PRODUCTS_ENDPOINTS,
    ...DISTRIBUTOR_ENDPOINTS,
    ...DATASET_ENDPOINTS,
    ...CUSTOM_CONFIG_ENDPOINTS,
    ...VIRTUAL_CATEGORY_ENDPOINTS,
    ...BFF_ENDPOINTS,
    ...FLASH_ORDER_ENDPOINTS,
    ...SHOPPING_LIST_ENDPOINTS,
    GET_ALL_SUPPLIERS: {
        path: '/national-referential/v1/suppliers',
        applyParams: () => `/national-referential/v1/suppliers`,
    },
    GET_ALL_CATEGORIES: {
        path: '/national-referential/v2/categories',
        applyParams: () => `/national-referential/v2/categories`,
    },
    GET_CROPS: {
        path: '/v1/crops',
        applyParams: () => `/v1/crops`,
    },
    GET_USAGES: {
        path: '/v1/usages',
        applyParams: () => `/v1/usages`,
    },
    GET_REDIRECTION: {
        path: '/v1/redirections',
    },
    GET_ATTRIBUTES: {
        path: '/v1/attributes',
        applyParams: () => `/v1/attributes`,
    },
};
